import * as actionType from '../action-type';

export const updateNwfaInstallationReport = (data) => ({
  type: actionType.UPDATE_NWFA_INSTALLATION_REPORT,
  payload: data,
});

export const resetNwfaInstallationReport = () => ({
  type: actionType.RESET_NWFA_INSTALLATION_REPORT,
});